import { SplashScreen, SuspenseBoundary } from '@agently/ui';
import { getMobileOS } from '@agently/utils';
import { useMount } from 'ahooks';
import { init, useAuthState } from 'auth';
import zodErrors from 'locales/zodErrors';
import { Outlet } from 'react-router';
import * as z from 'zod';

import { Error500 } from '@agently/components';

const App = () => {
  const { isLoaded } = useAuthState();

  useMount(() => {
    z.config({
      customError: zodErrors,
    });
    void init();
  });

  const mobileOS = getMobileOS();

  if (isLoaded !== 'true') return <SplashScreen />;

  return (
    <SuspenseBoundary
      fallback={<Error500 />}
      loadingFallback={<SplashScreen />}
    >
      <div className={mobileOS === 'Android' ? 'pt-2' : ''}>
        <Outlet />
      </div>
    </SuspenseBoundary>
  );
};

export default App;
